import { Component } from '@angular/core';

@Component({
  selector: 'header-desktop',
  templateUrl: './header-desktop.component.html',
  styleUrl: './header-desktop.component.scss',
  standalone: false,
})
export class HeaderDesktopComponent {}
